module.exports = __webpack_public_path__ + "static/media/trello-landing.5f2bcc06.jpeg";